import _isFunction from "lodash/isFunction";
import _pick from "lodash/pick";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-native-web-ui-components/Autocomplete';
import TextInputWidget from './TextInputWidget';
const allowedAttributes = ['allowEmpty', 'items', 'getItemValue', 'onSelect', 'isMatch', 'Item', 'Input', 'inputStyle', 'Menu', 'menuStyle', 'menuVisibleWhenFocused', 'itemHeight', 'itemProps', 'itemStyle', 'Spinner', 'spinnerHeight', 'EmptyResult', 'emptyResultHeight', 'throttleDelay', 'debounceDelay', 'throttleDebounceThreshold'];

const useOnSelect = ({
  name,
  onChange,
  onSelect,
  setText
}) => (value, item) => {
  setText.current(value);

  if (_isFunction(onSelect)) {
    onSelect(value, item);
  }

  return onChange(value, name);
};

const AutocompleteWidget = props => {
  const setText = useRef();
  const onSelect = useOnSelect({ ...props,
    setText
  });

  const register = fn => {
    setText.current = fn;
  };

  const inputProps = { ..._pick(props, allowedAttributes),
    onSelect,
    autoCapitalize: 'none'
  };
  return /*#__PURE__*/React.createElement(TextInputWidget, _extends({}, props, {
    changeOnBlur: false,
    register: register,
    onSelect: onSelect,
    Input: Autocomplete,
    inputProps: inputProps
  }));
};

AutocompleteWidget.hideable = false;
AutocompleteWidget.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default AutocompleteWidget;